<!--
 * @Author: your name
 * @Date: 2020-12-25 14:49:08
 * @Description: 带验证的输入框组件
 * @FilePath: /hsylc2021/src/components/form/CheckInput/checkInput.vue
-->
<template>
  <div class="component-checkInput">
    <Input
      :className="className"
      :size="size"
      :label="label"
      :placeholder="placeholder"
      :msg="isCheck ? errmsg : msg"
      :showMsg="showMsg"
      :error="isCheck ? inputError : error"
      :disabled="disabled"
      :type="type"
      :isFocus="focused"
      :isHover="hover"
      @keyup="handleKeyup"
      @blur="handleBlur"
      @input="handleInputChange"
      :value="value"
      :maxlength="maxlength"
    />
  </div>
</template>
<script>
import Input from '../Input';
import UTILS from '../../../utils/checkers';
const TYPES = {
  TEXT: 'text',
  TEL: 'tel',
  EMAIL: 'Email',
  PASSWORD: 'password',
  NUMBER: 'Number',
  PHONE: 'Phone',
  EN: 'En',
  VECIFY: 'vecifi'
};
/**
 * 带验证的输入框组件
 * @module checkInput
 */
export default {
  name: 'checkInput',
  /**
   * @prop {Boolean} isCheck 若为true  根据 input type 的值 在失焦时 进行输入框的格式判断 默认true
   * @prop {String} size 大小/高度 normal-48 small-36  默认normal
   * @prop {String} label 输入框标签 默认无，不展示
   * @prop {String} placeholder 水印文字 默认无，不展示
   * @prop {String} className 组件class
   * @prop {String} msg 提示文字 默认无，不展示
   * @prop {Boolean} showMsg 是否显示提示文字 默认true
   * @prop {Boolean} error 是否错误状态
   * @prop {Boolean} disabled 是否禁用状态
   * @prop {String} value 输入框内容
   * @prop {String} type 输入框类型 与input一致
   * @prop {Boolean} isFocus 是否聚焦 默认false
   * @prop {Boolean} isHover 是否鼠标覆盖 默认false
   * @prop {Boolean} startVerific 是否刚开始就验证 默认false
   */
  props: {
    isCheck: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'normal'
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    msg: {
      type: String,
      default: ''
    },
    showMsg: {
      type: Boolean,
      default: true
    },
    error: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    isFocus: {
      type: Boolean,
      default: false
    },
    isHover: {
      type: Boolean,
      default: false
    },
    startVerific: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    isVerific: {
      // 是否开启验证
      type: Boolean,
      default: true
    },
    maxlength: {
      type: Number,
      default: -1
    }
  },
  /**
   * @prop {Component} Input 输入框组件
   */
  components: {
    Input
  },

  watch: {
    // 组件 修改 v-model 值 检测 是否
    value() {
      // this.checkInput();
      if (this.startVerific && this.isVerific) this.checkInput();
    },
    startVerific(val) {
      if (val && this.isVerific) this.checkInput();
    },
    isFocus() {
      this.focused = this.isFocus;
    },
    isHover() {
      this.hover = this.isHover;
    }
  },
  /**
   * @prop {Boolean} focused 是否聚焦状态
   * @prop {Boolean} hover 是否鼠标覆盖状态
   * @prop {String} errmsg 错误信息
   * @prop {Boolean} inputError 是否输入框错误状态
   */
  data() {
    return {
      focused: false,
      hover: false,
      // 获取输入框的值
      errmsg: '',
      inputError: false
    };
  },
  mounted() {
    if (this.startVerific && this.isVerific) this.checkInput();
  },
  methods: {
    /**
     * @event blur 暴露blur事件
     */
    /**
     * @description 失焦 自动 验证
     * @function handleKeyup
     */
    handleKeyup() {
      if (this.isVerific) {
        this.checkInput();
      } else {
        this.inputError = false;
        this.errmsg = '';
      }
      // this.$emit('blur', !res, this.id, this.errmsg);
    },
    checkInput(val) {
      if (!this.isCheck) return;
      let res = null;
      let value = val ? val : this.value;
      switch (this.type) {
        case TYPES.TEXT:
          res = value ? true : false;

          if (!res) this.errmsg = '输入框不能为空';
          break;
        case TYPES.TEL:
          res = UTILS.checkMobile(value);
          if (!res) this.errmsg = '请填写11位手机!';
          break;

        case TYPES.EMAIL:
          res = UTILS.checkEmail(value);
          if (!res) this.errmsg = '邮箱格式错误！';
          break;
        case TYPES.PASSWORD:
          res = UTILS.checkPassword(value);
          if (!res) this.errmsg = '格式错误！密码为8-32位只能包含英文 数字 符号';
          break;
        case TYPES.NUMBER:
          if (value) {
            // res = UTILS.checkNumber(value);
            value = Number(value);
            res = typeof value === 'number' ? true : false;
            if (!res) this.errmsg = '请输入纯数字';
          } else {
            this.errmsg = '输入框不能为空';
          }
          break;
        case TYPES.PHONE:
          if (value) {
            res = UTILS.checkNumber(value);
            if (!res) this.errmsg = '请输入纯数字';
          } else {
            this.errmsg = '输入框不能为空';
          }
          break;

        case TYPES.EN:
          if (value) {
            res = UTILS.checkEn(value);
            if (!res) this.errmsg = '请输入纯英文';
          } else {
            res = false;
            if (!res) this.errmsg = '输入框不能为空';
          }

          break;
        case TYPES.VECIFY:
          res = UTILS.checkVecify(value);
          if (!res) this.errmsg = '验证码格式错误';
          break;

        default:
          res = true;
          break;
      }
      this.inputError = !res;
      if (res) this.errmsg = '';
      // console.log(this.errmsg);
      return res;
    },
    handleBlur() {
      let res = true;
      if (this.isVerific) {
        res = this.checkInput();
      } else {
        this.inputError = false;
        this.errmsg = '';
      }
      this.$emit('blur', !res, this.id, this.errmsg);
    },
    /**
     * @event input 暴露v-model绑定事件
     */
    /**
     * @description 输入内容change事件
     * @function handleInputChange
     * @param {Object} e 输入事件对象
     */
    handleInputChange: function(e) {
      let res = true;
      if (this.isVerific) {
        res = this.checkInput(e);
      } else {
        this.inputError = false;
        this.errmsg = '';
      }
      this.$emit('input', e, res, this.id, this.errmsg);
    }
  }
};
</script>
<style lang="less" scoped></style>
